import { COGNITO_APP_CLIENT_ID, COGNITO_REGION, COGNITO_USER_POOL_ID } from "../env";

export const COGNITO = {
  aws_cognito_region: COGNITO_REGION,
  aws_user_pools_id: COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: COGNITO_APP_CLIENT_ID,
};